export function generateTimeOptions(mode: '12' | '24', type: 'start' | 'end') {
  let options: { value: string; label: string }[] = []

  if (mode === '12') {
    // Loop through each hour of the 24-hour day (0 to 23)
    for (let i = 0; i < 24; i++) {
      // Calculate the hour in 12-hour format (12, 1, 2, ..., 11)
      const hour12 = i % 12 === 0 ? 12 : i % 12
      // Determine AM or PM based on the 24-hour index
      const period = i < 12 ? 'AM' : 'PM'
      // Get the 24-hour representation for the 'value' field
      const valueHour = i.toString().padStart(2, '0')

      // Add the option for the top of the hour (e.g., 1:00 PM)
      options.push({
        value: `${valueHour}:00`,
        label: `${hour12}:00 ${period}`,
      })

      // Add the option for the half-hour mark (e.g., 1:30 PM)
      options.push({
        value: `${valueHour}:30`,
        label: `${hour12}:30 ${period}`,
      })
    }
  } else {
    // --- 24-hour logic remains the same ---
    for (let i = 0; i <= 24; i++) {
      const valueHour = i.toString().padStart(2, '0')
      options.push({
        value: `${valueHour}:00`,
        label: `${valueHour}:00`,
      })
      // Only add half hours up to 23:30
      if (i < 24) {
        options.push({
          value: `${valueHour}:30`,
          label: `${valueHour}:30`,
        })
      }

      // exclude 24:00 if type is start
      if (type === 'start' && valueHour === '24') {
        options = options.filter((option) => option.value !== '24:00')
      }

      // exclude 00:00 if type is end
      if (type === 'end' && valueHour === '00') {
        options = options.filter((option) => option.value !== '00:00')
      }
    }
  }

  return options
}
